import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_new_brand_discoveries: FaireThemeEntity = {
  token: "discovery_theme_new-brand-discoveries",
  type: "theme",
  retailerToken: "r_discovery",
  name: "New Brand Discoveries",
  description: "Fresh brands making waves on Faire",
  bgColor: "#D4F0D8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
